<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.cztcode" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname" :value="item.ccorpcode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="送货日期">
          <!-- <el-date-picker v-model="formInline.ddeliverytime" type="date" value-format="yyyy-MM-dd" placeholder="送货日期"></el-date-picker> -->
          <el-date-picker v-model="formInline.ddeliverytime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="GetSHList()" size="medium">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetSHList()" size="medium">查询</el-button>
          </Debounce>
          <el-button type="success" size="medium" @click="addoption('1')">新增</el-button>
          <!-- <el-button type="warning" plain size="medium" @click="printpage()">打印</el-button> -->
        </el-form-item>
      </el-form>
      <div class="text item text-center">
        <div class="pull-right" style="margin-bottom:15px"></div>
        <el-table :data="orderlist" style="width: 100%" max-height="560" border :cell-style="{ padding: '7px 0',textAlign: 'center' }" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" @current-change="clickChange">
          <!-- <el-table-column label="选择" width="55">
            <template slot-scope="scope">
              <el-radio v-model="tableRadio" :label="scope.row">
                <i>
                </i>
              </el-radio>
            </template>
          </el-table-column> -->
          <el-table-column prop="ciscommit" label="提交状态" width="120">
            <template slot-scope="scope">
              <el-tag type="success" size="small" v-if="scope.row.ciscommit=='是'">已提交</el-tag>
              <el-tag type="danger" size="small" v-else effect="dark">未提交</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ccorpname" label="公司名称" min-width="120"></el-table-column>
          <!-- <el-table-column prop="csapcode" label="SAP订单号" min-width="120"></el-table-column> -->
          <!-- <el-table-column prop="ccode" label="送货单号" min-width="120"></el-table-column> -->
          <el-table-column prop="ddeliverytime" label="送货日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.ddeliverytime"> {{scope.row.ddeliverytime.substring(0,10)}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="ccarcode" label="车牌号" width="100"></el-table-column>
          <el-table-column prop="dyjdeliverytime" label="预计到货日期" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.dyjdeliverytime"> {{scope.row.dyjdeliverytime.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cdeliveryname" label="送达方" width="120"></el-table-column> -->
          <!-- <el-table-column prop="cdeliverycode" label="送达方编号" width="160"></el-table-column>    -->
          <el-table-column prop="cremark" label="备注" width="160"></el-table-column>
          <el-table-column prop="ddate" label="制单日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.ddate"> {{scope.row.ddate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dcommit" label="提交日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.dcommit"> {{scope.row.dcommit.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="addoption(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>

      </div>
    </el-card>
    <operprint v-if="prinpageif" :prinpageif="prinpageif" :prinpagesrc="prinpagesrc" @printclose="printclose" />
  </div>
</template>

<script>
import operprint from "./Operation/Operatiopint.vue";
export default {
  components: { operprint },
  data() {
    return {
      alwaysUseStartDate: [],
      formInline: {
        cztcode: "",
        ddeliverytime: [],
      },
      tableRadio: {
        ccode: "",
        cvenname: "",
        cvencode: "",
        ddeliverytime: "",
        ccarcode: "",
        ccorpname: "",
        dyjdeliverytime: "",
        cdeliveryname: "",
        cdeliverycode: "",
        cremark: "",
        cmaker: "",
        ddate: "",
        ciscommit: "",
        dcommit: "",
      },

      orderlist: [],
      selectlist: {},
      prinpageif: false,
      prinpagesrc: "",
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.cztcode != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GetSHList();
    this.GetAccountInfo();
  },
  methods: {
    addoption(val) {
      if (val == 1) {
        this.tableRadio = {
          id: "",
          cdeliverycode: "",
          cdeliveryname: "",
          cremark: "",
          cvencode: JSON.parse(localStorage.getItem("userdata")).csrmcode,
          cvenname: JSON.parse(localStorage.getItem("userdata")).ccustomername,
          ddeliverytime: "",
          dyjdeliverytime: "",
          ccorpcode: "",
          ddate: "",
          ccorpname: "",
          ccarcode: "",
        };
        // this.$router.push({ path: "/Operationadd", params:{id: "5464"}});
        this.$router.push({
          name: "Operationadd",
          params: {
            tableRadio: this.tableRadio,
            selectlist: this.selectlist,
            informdata: this.informdatanew,
          },
        });
      } else {
        this.tableRadio = val;
        this.$router.push({
          name: "Operationadd",
          params: {
            tableRadio: this.tableRadio,
            selectlist: this.selectlist,
            informdata: this.informdatanew,
          },
        });
      }
    },
    // 获取订单
    GetSHList() {
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetSHList",
        data: {
          starttime: starttime,
          endtime: endtime,
          cztcode: this.formInline.cztcode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.rows) {
          this.totalCount = res.data.totalCount;
          this.orderlist = res.data.rows;
        }
      });
    },
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    clickChange(item) {
      this.tableRadio = item;
    },

    printclose(val) {
      this.prinpageif = val;
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSHList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetSHList();
    },
  },
};
</script>
